var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-inline share-icons music-play-lists"},[_c('li',{staticClass:"share"},[_c('span',{on:{"click":_vm.share}},[_c('i',{staticClass:"ri-share-fill"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }